import { useCallback, useEffect, useState } from "react";

import displayToast from "@common/components/Toast/displayToast";
import { useAppSelectionContext } from "@main/context/App/AppSelectionContext";
import { useTeamMembersConsumer } from "@main/pages/Administration/consumers/useTeamMembersConsumer";
import { useUserFeedbackDeps } from "@main/pages/UserFeedback/UserFeedback";
import { RoutePaths } from "@main/router/config/routePaths";
import { generatePath, useNavigate } from "react-router-dom";

export const useNoSubscriptionConsumer = () => {
  const navigate = useNavigate();
  const { selectedWorkspace, selectedApp } = useAppSelectionContext();

  const { userFeedbackService } = useUserFeedbackDeps();
  const { teamData } = useTeamMembersConsumer();
  const [loading, setLoading] = useState(false);

  const fetchNoSubscriptionInitialData = useCallback(async () => {
    if (!selectedApp || !selectedWorkspace) return;
    setLoading(true);
    try {
      const issues = await userFeedbackService.getUserFeedbackTickets(selectedWorkspace.id, selectedApp.id, 20, 10);

      if (issues) {
        navigate(
          generatePath(RoutePaths.USER_FEEDBACK, {
            workspaceSlug: selectedWorkspace.slug,
            appKey: selectedApp.key,
          }),
        );
      }
    } catch (error) {
      displayToast({ title: "Something went wrong", content: "Please try again." });
    } finally {
      setLoading(false);
    }
  }, [selectedApp, selectedWorkspace, userFeedbackService, navigate]);

  useEffect(() => {
    fetchNoSubscriptionInitialData();
  }, [fetchNoSubscriptionInitialData]);

  return { teamData, loading };
};
